var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "#2e3e4d",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.9215L14.6435 2.92149C16.8625 2.95865 18.9826 3.85627 20.5546 5.42819C22.1603 7.03397 23.0625 9.21187 23.0625 11.4828V16.3161V16.4232L23.1063 16.5208L24.8192 20.3381C24.8193 20.3383 24.8194 20.3384 24.8194 20.3385C24.8633 20.437 24.8818 20.5448 24.8735 20.6523C24.8651 20.7599 24.83 20.8637 24.7713 20.9543L25.191 21.2261L24.7713 20.9543C24.7127 21.0449 24.6323 21.1194 24.5375 21.171C24.4427 21.2227 24.3365 21.2498 24.2286 21.25H4.77537C4.77535 21.25 4.77532 21.25 4.77529 21.25C4.66725 21.25 4.56092 21.2229 4.46599 21.1713C4.37104 21.1197 4.29051 21.0451 4.23174 20.9544C4.17297 20.8637 4.13782 20.7598 4.12949 20.652C4.12117 20.5443 4.13991 20.4362 4.18401 20.3376C4.18403 20.3375 4.18405 20.3375 4.18407 20.3375L5.8938 16.5193L5.93746 16.4217V16.3149V11.4721L5.94333 11.1788C6.02235 8.96294 6.95789 6.86403 8.55316 5.32389C10.1493 3.78289 12.2813 2.9216 14.5 2.9215ZM12.4829 24.7443C12.0741 24.3988 11.7635 23.9565 11.5766 23.462H17.4233C17.2364 23.9565 16.9259 24.3988 16.517 24.7443C15.953 25.221 15.2384 25.4825 14.5 25.4825C13.7615 25.4825 13.0469 25.221 12.4829 24.7443Z",
    stroke: "#2E3E4D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 6,
    r: 6,
    fill: "#F38181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFilled);
export default __webpack_public_path__ + "static/media/alertFilled.ab228d74.svg";
export { ForwardRef as ReactComponent };